<div class="container">
  <mat-card>
    <form [formGroup]="taxComponentForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            @if (taxComponentForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Percentage' | translate }}</mat-label>
            <input matInput required formControlName="percentage" />
            @if (taxComponentForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Percentage' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          @if (taxComponentData?.creditAccountType?.value) {
            <mat-form-field>
              <mat-label>{{ 'labels.inputs.Credit Account Type' | translate }}</mat-label>
              <input matInput formControlName="creditAccountType" />
            </mat-form-field>
          }

          @if (taxComponentData?.creditAccount?.name) {
            <mat-form-field>
              <mat-label>{{ 'labels.inputs.Credit Account' | translate }}</mat-label>
              <input matInput formControlName="creditAccount" />
            </mat-form-field>
          }

          <mat-form-field (click)="startDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Start Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="startDatePicker"
              required
              formControlName="startDate"
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
            @if (taxComponentForm.controls.startDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Start Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!taxComponentForm.valid"
          *LOSxHasPermission="'UPDATE_TAXCOMPONENT'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
